/**
 * (Группа 10) Модерация отзывов.
 *
 * Backend reviews существует (REAL /v1/admin/reviews|room-reviews), экраны
 * модерации — каркас.
 */
import { PageStub } from '../../shared/PageStub.js';

export function ReviewsPage(): JSX.Element {
  return (
    <PageStub
      testId="reviews-page"
      title="Модерация отзывов"
      description="Отзывы, помеченные как спам/оскорбления, и решения по ним."
      sections={[
        'Список помеченных отзывов с фильтром по типу флага',
        'Карточка отзыва: текст, автор, рейтинг, причина флага',
        'Действия: оставить / скрыть / удалить / забанить автора',
      ]}
      dataSource="REAL /v1/admin/reviews + /v1/admin/room-reviews; экраны модерации — каркас"
    />
  );
}
